import {
  SET_RECEIPT_UPLOAD_DATA,
  SET_GENERAL_RECEIPT_DATA,
  SET_GENERAL_RECEIPT_LIST_DATA,
  SET_RECEIPT_RECEIPT_CANCELLATION_DATA,
} from 'src/store/types'
import helpers from 'src/helpers'
import Vue from 'vue'

export default {
  [SET_RECEIPT_UPLOAD_DATA](state, payload) {
    state.processedReceiptData = { ...payload }
  },
  [SET_GENERAL_RECEIPT_DATA](state, payload) {
    if (!helpers.isSet(payload, 'selected.payments')) {
      payload = {
        ...payload,
        ...{
          selected: {
            payments: {
              paid: [...helpers.getValue(payload, 'payments', [])],
              unpaid: [],
            },
          },
        },
      }
    }
    state.generalReceiptData = { ...payload }
  },
  [SET_RECEIPT_RECEIPT_CANCELLATION_DATA](state, payload) {
    state.generalReceiptData = { ...state.generalReceiptData, ...{ receipt_cancellation: payload } }
  },
  [SET_GENERAL_RECEIPT_LIST_DATA](state, payload) {
    Vue.set(state.generalReceiptListData, 'list', payload.list)
  },
}
